import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import moment from 'moment-timezone';
import 'moment/locale/ko';

export type CategoryType = {
  category_id: number;
  category_name: string;
  category_name2: string;
  cate_id_order: number;
  is_for_adult: number;
  product_list: ProductType[];
};
export type ProductType = {
  prd_id: number;
  prd_name: string;
  prd_name2: string;
  prd_description: string;
  prd_base_price: number;
  prd_base_price_nrm: string;
  prd_org_price: number;
  prd_org_price_nrm: string;
  prd_discount_percentage: number;
  prd_discount_percentage_nrm: string;
  prd_discount_direction: string;
  is_set: number;
  is_hide: number;
  is_soldout: number;
  url_path: string | null;
  product_media_id: number | null;
  id_order: number;
};
export type ProductOptionType = {
  option_input_max: number;
  option_input_min: number;
  option_list: OptionItemType[];
  option_type_id: number;
  option_type_name: string;
  option_type_name2: string;
  option_type_order: number;
};
export type OptionGroupType = {
  input_min: number;
  input_max: number;
  option_list: OptionGroupItemType[];
  option_type_id: number;
  id_order: number;
  name: string;
  description: string;
};
export type OptionGroupItemType = {
  option_id?: number;
  name: string;
  price: number;
  description: string;
};
export type OptionItemType = {
  option_id: number;
  option_name: string;
  option_name2: string;
  option_price: number;
  option_price_nrm: string;
};
export type InventoryType = {
  stock_update_type: number; // 사용 여부
  in_stock: number; // 실재고량
  category_id: number;
  category_name: string;
  prd_id: number;
  prd_name: string;
  default_stock: number; // 일일 재고량
  stock_update_time: string; // 재고 채워지는 시간
};
export type SetMenuType = {
  category_list: SetCategoryType[];
  set_prd_id: number;
  set_prd_name: string;
  set_prd_description: string;
  set_base_price: number;
  set_org_price: number;
  is_soldout: number;
  is_hide: number;
  product_media_id: number | null;
  url_path: string;
  set_prd_type_list: SetMenuItemType[];
  option_group_list: SetMenuItemType[];
};
export type SetMenuItemType = {
  set_type_id?: number;
  set_type_name: string;
  input_min: number;
  input_max: number;
  id_order: number;
  product_list: SetItemProductType[];
};
export type SetCategoryType = {
  category_id: number;
  id_order: number;
  is_for_adult: number;
  is_main: number;
  name: string;
  set_prd_id: number;
};
export type SetItemProductType = {
  prd_id: number;
  prd_name: string;
  prd_description: string;
  price: number;
  prd_base_price: number;
  prd_org_price: number;
  is_hide: number;
  is_soldout: number;
  url_path: string | null;
  product_media_id: number | null;
  id_order: number;
};

const menuVersionUpdate = async () => {
  try {
    let oParams = {
      menu_ver: moment().valueOf(),
    };
    let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/store/setMenuVer';
    const response: any = await Axios.post(sUrl, oParams);
    return response;
  } catch (err) {
    let oErr: any = err;
    return {
      ok: false,
      msg: '[로그인 오류]' + oErr.toString(),
      data: undefined,
    };
  }
};

const ProductController = {
  // 카테고리 불러오기
  getAllCateProduct: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/8/${storeId}/getAllCateProduct`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[카테고리 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 상품 카테고리 불러오기
  getCateList: async (productId: number, isSet: number) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/${productId}/${isSet}/getCateList`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 카테고리 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 카테고리 생성
  setCateProduct: async (storeId: number, category: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/setCateProduct`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        category: category,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[카테고리 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 카테고리 수정
  editCateProduct: async (storeId: number, category: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editCateProduct`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        category: category,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[카테고리 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 카테고리 삭제
  delCategory: async (categoryId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/delCategory`;
      const oParams = {
        category_id: categoryId,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[카테고리 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 카테고리 순서 변경
  editCateProductIdOrder: async (storeId: number, categoryList: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editCateProductIdOrder`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        category_list: categoryList,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[카테고리 순서 변경 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 카테고리 내 상품
  getCateProduct: async (store_id: number, category_id: number) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL +
        `/menu/${store_id}/${category_id}/getCateProduct`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[카테고리 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 전체상품 불러오기
  getAllProductList: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/${storeId}/getAllProductList`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[전체상품 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 상품 생성
  setProduct: async (storeId: number, product: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/setProduct`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        product: product,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 상품 수정
  editProduct: async (storeId: number, product: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editProduct`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        product: product,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 상품, 세트상품 삭제
  delProduct: async (productId: number, isSet: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/delProduct`;
      const oParams = {
        product_id: productId,
        is_set: isSet,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 옵션그룹 불러오기
  getAllOptionGroup: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/8/${storeId}/getAllOptionGroup`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[옵션그룹 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 상품 옵션 불러오기
  getOptions: async (productId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/${productId}/getOptions`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 옵션 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 옵션 생성
  setOptionGroup: async (storeId: number, option_group: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/setOptionGroup`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        option_group: option_group,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[옵션 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 옵션 수정
  editOptionGroup: async (storeId: number, option_group: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editOptionGroup`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        option_group: option_group,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[옵션 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 옵션 삭제
  delOptionGroup: async (optionId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/delOptionGroup`;
      const oParams = {
        option_type_id: optionId,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[옵션 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 옵션 순서 변경
  editOptionGroupIdOrder: async (storeId: number, optionGroupList: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editOptionGroupIdOrder`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        option_group_list: optionGroupList,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[옵션 순서 변경 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 상품 재고 불러오기
  getSupplyProduct: async (storeId: number, categoryId: number) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL +
        `/menu/${storeId}/${categoryId}/getSupplyProduct`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 재고 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 재고 수정
  setSupplyProduct: async (supplyList: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/setSupplyProduct`;
      const oParams = {
        supply_list: supplyList,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[재고 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트메뉴 불러오기
  getAllSetProductList: async (storeId: number) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/8/${storeId}/getAllSetProductList`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트메뉴 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트메뉴 생성
  setSetProduct: async (storeId: number, setProduct: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/setSetProduct`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        set_product: setProduct,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트메뉴 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트메뉴 수정
  editSetProduct: async (storeId: number, setProduct: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editSetProduct`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        set_product: setProduct,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트메뉴 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트메뉴 순서 변경
  editSetProductIdOrder: async (storeId: number, setProductList: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editSetProductIdOrder`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        set_product_list: setProductList,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트메뉴 순서 변경 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트상품 불러오기
  getAllSetPrdGroup: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/8/${storeId}/getAllSetPrdGroup`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트상품 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트상품 생성
  setSetPrdGroup: async (storeId: number, setPrdType: SetMenuItemType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/setSetPrdGroup`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        set_prd_type: setPrdType,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트상품 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트상품 수정
  editSetPrdGroup: async (storeId: number, setPrdType: SetMenuItemType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editSetPrdGroup`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        set_prd_type: setPrdType,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트상품 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트상품 삭제
  delSetPrdGroup: async (setTypeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/delSetPrdGroup`;
      const oParams = {
        set_type_id: setTypeId,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트상품 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 세트상품 순서 변경
  editSetPrdGroupIdOrder: async (storeId: number, setPrdTypeList: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/editSetPrdGroupIdOrder`;
      const oParams = {
        app_type: 8,
        store_id: storeId,
        menu_version_seq: 0,
        set_prd_type_list: setPrdTypeList,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[세트상품 순서 변경 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default ProductController;
